import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceNoLookup extends Layout {
}
